export default {
   OK: "យល់ព្រម",
  ok: "យល់ព្រម",
  loginFailed: "ការចូលបានបរាជ័យ សូមព្យាយាមម្តងទៀត។",
  requestFailed: "សំណើបានបរាជ័យ សូមពិនិត្យការតភ្ជាប់អ៊ីនធឺណិតរបស់អ្នក។",
  invalidLogin: "ឈ្មោះអ្នកប្រើ ឬពាក្យសម្ងាត់មិនត្រឹមត្រូវ។",
  invalidPassword: "ឈ្មោះអ្នកប្រើ ឬពាក្យសម្ងាត់មិនត្រឹមត្រូវ។",
  thisFunctionExists: "មុខងារនេះមានរួចហើយ។",
  thisFunctionNotAllowDelete: "មុខងារនេះមិនអាចលុបបានទេ។",
  thisFunctionNotExists: "មុខងារនេះមិនមានទេ។",
  targetFunctionIdRequired: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់មុខងារ។",
  thisPageExists: "ទំព័រនេះមានរួចហើយ។",
  thisPageNotAllowDelete: "ទំព័រនេះមិនអាចលុបបានទេ។",
  thisRoleExists: "តួនាទីនេះមានរួចហើយ។",
  thisRoleNotAllowDelete: "តួនាទីនេះមិនអាចលុបបានទេ។",
  targetRoleIdRequired: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់តួនាទី។",
  invalidParameter: "ប៉ារ៉ាម៉ែត្រមិនត្រឹមត្រូវ។",
  systemError: "ប្រព័ន្ធមិនអាចដំណើរការសំណើរបស់អ្នកបានទេ។",
  spErrorMessage: "កំហុសសារ SP (អាស្រ័យលើកំហុស)",
  actionbyRequired: "តម្រូវឲ្យបញ្ចូលអ្នកប្រើបច្ចុប្បន្ន។",
  sessionTokenRequired: "តម្រូវឲ្យបញ្ចូលសេសសិនតូខិន។",
  functionIdRequired: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់មុខងារ។",
  functionNameRequired: "តម្រូវឲ្យបញ្ចូលឈ្មោះមុខងារ។",
  newFunctionNameRequired: "តម្រូវឲ្យបញ្ចូលឈ្មោះមុខងារ។",
  pageIdRequired: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់ទំព័រ។",
  newPageIdRequired: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់ទំព័រ។",
  newPageNameRequired: "តម្រូវឲ្យបញ្ចូលឈ្មោះទំព័រ។",
  targetPageIdRequired: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់ទំព័រគោលដៅ។",
  userIdRequired: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់អ្នកប្រើប្រាស់។",
  passwordRequired: "តម្រូវឲ្យបញ្ចូលពាក្យសម្ងាត់។",
  userNameRequired: "តម្រូវឲ្យបញ្ចូលឈ្មោះពេញ។",
  passwordValidation: "ពាក្យសម្ងាត់ត្រូវមានចន្លោះពី 6-20 តួ និងរួមបញ្ចូលអក្សរនិងលេខ។",
  pageNumRequired: "តម្រូវឲ្យបញ្ចូលលេខទំព័រ។",
  pageSizeRequired: "តម្រូវឲ្យបញ្ចូលទំហំទំព័រ។",
  roleIdRequired: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់តួនាទី។",
  oldPasswordRequired: "តម្រូវឲ្យបញ្ចូលពាក្យសម្ងាត់ចាស់។",
  userStatusRequired: "តម្រូវឲ្យបញ្ចូលស្ថានភាពអ្នកប្រើ។",
  newRoleIdRequired: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់តួនាទីថ្មី។",
  newRoleNameRequired: "តម្រូវឲ្យបញ្ចូលឈ្មោះតួនាទីថ្មី។",
  startDateRequired: "តម្រូវឲ្យបញ្ចូលកាលបរិច្ឆេទចាប់ផ្តើម។",
  endDateRequired: "តម្រូវឲ្យបញ្ចូលកាលបរិច្ឆេទបញ្ចប់។",
  startDateIsGteEndDate: "កាលបរិច្ឆេទចាប់ផ្តើមធំជាងកាលបរិច្ឆេទបញ្ចប់។",
  sportsTypeRequired: "តម្រូវឲ្យជ្រើសប្រភេទកីឡា។",
  teamTypeRequired: "តម្រូវឲ្យជ្រើសប្រភេទក្រុម។",
  thisRoleNotExists: "តួនាទីនេះមិនមានទេ។",
  thisPageNotExists: "ទំព័រនេះមិនមានទេ។",
  thisUserExists: "អ្នកប្រើប្រាស់នេះមានរួចហើយ។",
  thisUserNotExists: "អ្នកប្រើប្រាស់នេះមិនមានទេ។",
  thisUserBlackListed: "គណនីរបស់អ្នកត្រូវបានផ្អាក។",
  thisUserInactive: "គណនីរបស់អ្នកត្រូវបានបិទ។",
  thisUserBlocked: "គណនីរបស់អ្នកត្រូវបានទប់ស្កាត់។",
  thisUserNotActive: "គណនីរបស់អ្នកត្រូវបានបិទ។",
  InvalidPageFunction: "មុខងារទំព័រមិនត្រឹមត្រូវ។",
  invalidUser: "អ្នកប្រើមិនត្រឹមត្រូវ!",
  invalidToken: "សម័យមិនត្រឹមត្រូវ!",
  NoUserAccessRight: "គ្មានសិទ្ធិប្រើប្រាស់!",
  unableSPProcess: "ប្រព័ន្ធមិនអាចដំណើរការសំណើរបស់អ្នកបានទេ។",
  connection: "កំហុសការតភ្ជាប់",


  isRequired: "សូមបញ្ចូល {fname}។",
  isMinValue: "{fname} ត្រូវតែមានតិចបំផុត {fvalue}។",
  isMaxValue: "{fname} ត្រូវតែតិចជាង ឬស្មើនឹង {fvalue}។",
  isMinLength: "{fname} ត្រូវតែមានយ៉ាងហោចណាស់ {fvalue} តួអក្សរ។",
  isMaxLength: "{fname} ត្រូវតែមានតួអក្សរតិចជាង ឬស្មើនឹង {fvalue}។",
  isAlpha: "{fname} អនុញ្ញាតតែអក្សរតែប៉ុណ្ណោះ។",
  isAlphaNum: "{fname} អាចបញ្ចូលតែអក្សរ និងលេខប៉ុណ្ណោះ។",
  isNumeric: "{fname} អាចបញ្ចូលតែលេខប៉ុណ្ណោះ។",
  isEmail: "{fname} ត្រូវតែជាអាសយដ្ឋានអ៊ីមែលត្រឹមត្រូវ។",
  isIpAddress: "{fname} ត្រូវតែជាអាសយដ្ឋាន IPv4 ត្រឹមត្រូវ។",
  isSameAs: "{fname} ត្រូវតែដូចគ្នានឹង {fname2}។",
  isUrl: "{fname} ត្រូវតែជា URL ត្រឹមត្រូវ។",
  containAlphaNum: "{fname} ត្រូវមានយ៉ាងហោចណាស់អក្សរមួយ និងលេខមួយ។",
  selectOption: "សូមជ្រើសរើស {fname}។",
  notSameAs: "{fname} និង {fname2} មិនអាចដូចគ្នា។",
  isBetween: "{fname} ត្រូវស្ថិតនៅចន្លោះ {min} និង {max}។",
  isSSFormat: "ទ្រង់ទ្រាយលេខគណនីអ្នកដ៏ចាស់មិនត្រឹមត្រូវ។",
  isReserved: "លេខគណនីត្រូវបានបម្រុងទុក។",
  isExisted: "លេខគណនីមានរួចហើយ។",
  onlySmallCapsAlphaNum: "អនុញ្ញាតតែអក្សរតូច និងលេខពី a ដល់ z និង 0 ដល់ 9 ប៉ុណ្ណោះ។",

  system_error: "ប្រព័ន្ធមិនអាចដំណើរការសំណើរបស់អ្នកបានទេ។",
  invalid_password: "ឈ្មោះអ្នកប្រើ ឬពាក្យសម្ងាត់មិនត្រឹមត្រូវ។",
  block: "គណនីរបស់អ្នកត្រូវបានទប់ស្កាត់។",
  invalid_security_code: "លេខសុវត្ថិភាពមិនត្រឹមត្រូវ។",

  source_account_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់គណនី។",
  target_account_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់គណនីគោលដៅ។",
  permission_denied: "មិនមានសិទ្ធិអនុញ្ញាត។",
  account_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់គណនី។",
  sub_login_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់ចូល។",
  account_not_exists: "គណនីមិនមានទេ។",
  profile_not_exists: "ប្រវត្តិមិនមានទេ។",
  account_inactive: "គណនីអសកម្ម។",
  not_blocked_account: "គណនីត្រឹមត្រូវ។",
  password_required: "តម្រូវឲ្យបញ្ចូលពាក្យសម្ងាត់។",
  parent_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់ឪពុក/ម្ដាយ។",
  parent_not_exists: "លេខសម្គាល់ឪពុក/ម្ដាយមិនមានទេ។",
  invalid_account_type: "ប្រភេទគណនីមិនត្រឹមត្រូវ។",
  account_exists: "គណនីមានរួចហើយ។",
  login_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់ចូល។",
  new_login_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់ចូលថ្មី។",
  login_id_not_exists: "លេខសម្គាល់ចូលមិនមានទេ។",
  invalid_authority_role: "តួនាទីមិនត្រឹមត្រូវ។",
  profile_inactive: "ប្រវត្តិមិនសកម្ម។",
  secondary_account_exists: "គណនីរងមានរួចហើយ។",
  new_login_id_exists: "លេខសម្គាល់ចូលថ្មីមានរួចហើយ។",
  new_password_required: "តម្រូវឲ្យបញ្ចូលពាក្យសម្ងាត់ថ្មី។",
  security_tag_required: "តម្រូវឲ្យបញ្ចូលស្លាកសុវត្ថិភាព។",
  security_code_required: "តម្រូវឲ្យបញ្ចូលលេខសុវត្ថិភាព។",
  start_date_required: "តម្រូវឲ្យបញ្ចូលកាលបរិច្ឆេទចាប់ផ្តើម។",
  end_date_required: "តម្រូវឲ្យបញ្ចូលកាលបរិច្ឆេទបញ្ចប់។",
  start_date_gt_end_date: "កាលបរិច្ឆេទចាប់ផ្តើមធំជាងកាលបរិច្ឆេទបញ្ចប់។",
  member_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់សមាជិក។",
  currency_code_required: "តម្រូវឲ្យបញ្ចូលកូដរូបិយប័ណ្ណ។",
  commission_setting_not_exists: "ការកំណត់កម្រៃជើងសារមិនមានទេ។",
  incomplete_account_line: "បន្ទាត់គណនីមិនបានបំពេញពេញលេញ។",
  invalid_hdp_package: "កញ្ចប់ HDP មិនត្រឹមត្រូវ។",
  search_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់ស្វែងរក។",
  profile_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់ប្រវត្តិ។",
  login_not_exists: "ការចូលមិនមានទេ។",
  no_changes: "មិនមានការផ្លាស់ប្តូរត្រូវបានរកឃើញ។",
  start_date_require: "តម្រូវឲ្យបញ្ចូលកាលបរិច្ឆេទចាប់ផ្តើម។",
  league_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់លីគ។",
  sport_type_required: "តម្រូវឲ្យបញ្ចូលប្រភេទកីឡា។",
  match_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់ការប្រកួត។",
  target_login_id_required: "តម្រូវឲ្យបញ្ចូលលេខសម្គាល់ចូលគោលដៅ។",
  parent_account_not_exists: "គណនីឪពុក/ម្ដាយមិនមានទេ។",
  parent_account_inactive: "គណនីឪពុក/ម្ដាយអសកម្ម។",
  parent_profile_not_exists: "ប្រវត្តិឪពុក/ម្ដាយមិនមានទេ។",
  parent_profile_inactive: "ប្រវត្តិឪពុក/ម្ដាយអសកម្ម។",
  target_login_id_not_exists: "លេខសម្គាល់ចូលគោលដៅមិនមានទេ។",
  incorrect_parent: "លេខសម្គាល់ឪពុក/ម្ដាយមិនត្រឹមត្រូវ។",
  invalid_session: "សម័យមិនត្រឹមត្រូវ។",
  session_expired: "សម័យបានផុតកំណត់។",
  settle_amount_required: "តម្រូវឲ្យបញ្ចូលចំនួនសងប្រាក់។",
  invalid_settle_amount: "ចំនួនសងប្រាក់មិនត្រឹមត្រូវ។",
  settle_amount_gt_yesterday_balance: "ចំនួនសងប្រាក់ធំជាងសមតុល្យម្សិលមិញ។",
  invalid_account_status: "ស្ថានភាពគណនីមិនត្រឹមត្រូវ។",
  bet_limit_packages_required: "តម្រូវឲ្យបញ្ចូលកញ្ចប់កំណត់ភ្នាល់។",
  bet_limit_exists: "កំណត់ភ្នាល់មានរួចហើយ។",
  member_bet_limit_package_gt_one: "សមាជិកមានកញ្ចប់កំណត់ភ្នាល់ច្រើនជាងមួយ។",
  parent_bet_limit_not_exists: "កំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  account_commission_required: "តម្រូវឲ្យបញ្ចូលកម្រៃជើងសារគណនី។",
  commission_setting_exists: "ការកំណត់កម្រៃជើងសារមានរួចហើយ។",
  parent_comm_not_exists: "កំណត់កម្រៃជើងសាររបស់ឪពុក/ម្ដាយមិនមានទេ។",
  exceeded_parent_comm: "លើសកម្រៃជើងសាររបស់ឪពុក/ម្ដាយ។",
  others_commission_required: "តម្រូវឲ្យបញ្ចូលកម្រៃជើងសារផ្សេងៗ។",
  exceeded_parent_1x2: "លើសកម្រៃជើងសារ 1x2 របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_other: "លើសកម្រៃជើងសារផ្សេងៗរបស់ឪពុក/ម្ដាយ។",
  hdp_commission_required: "តម្រូវឲ្យបញ្ចូលការកំណត់កម្រៃជើងសារ HDP។",
  exceeded_parent_hdp_a: "លើសកម្រៃជើងសារ HPD(A) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_b: "លើសកម្រៃជើងសារ HPD(B) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_c: "លើសកម្រៃជើងសារ HPD(C) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_d: "លើសកម្រៃជើងសារ HPD(D) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_e: "លើសកម្រៃជើងសារ HPD(E) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_f: "លើសកម្រៃជើងសារ HPD(F) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_g: "លើសកម្រៃជើងសារ HPD(G) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_h: "លើសកម្រៃជើងសារ HPD(H) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_i: "លើសកម្រៃជើងសារ HPD(I) របស់ឪពុក/ម្ដាយ។",
  exceeded_parent_hdp_j: "លើសកម្រៃជើងសារ HPD(J) របស់ឪពុក/ម្ដាយ។",
  LIVECASINO_upline_pt_required: "[Livecasino] តម្រូវឲ្យបញ្ចូលការកំណត់ PT របស់ឪពុក/ម្ដាយ។",
  LIVECASINO_pt_setting_exists: "[Livecasino] ការកំណត់ PT មានរួចហើយ។",
  LIVECASINO_parent_pt_not_exists: "[Livecasino] ការកំណត់ PT របស់ឪពុក/ម្ដាយមិនមានទេ។",
  LIVECASINO_parent_min_not_meet: "[Livecasino] មិនត្រូវនឹង PT អប្បបរមារបស់ឪពុក/ម្ដាយ។",
  LIVECASINO_exceeded_parent_pt: "[Livecasino] លើសការកំណត់ PT របស់ឪពុក/ម្ដាយ។",
  LIVECASINO_account_pt_required: "[Livecasino] តម្រូវឲ្យបញ្ចូលការកំណត់ PT របស់គណនី។",
  LIVECASINO_upline_remaining_required: "[Livecasino] តម្រូវឲ្យបញ្ចូល PT ដែលនៅសល់របស់ឪពុក/ម្ដាយ។",
  LIVECASINO_account_min_required: "[Livecasino] តម្រូវឲ្យបញ្ចូល PT អប្បបរមារបស់គណនី។",
  LIVECASINO_upline_remaining_gt_account_pt: "[Livecasino] PT ដែលនៅសល់របស់ឪពុក/ម្ដាយធំជាង PT របស់គណនី។",
  LIVECASINO_account_min_gt_p: "[Livecasino] PT អប្បបរមារបស់គណនីធំជាង PT របស់ឪពុក/ម្ដាយ។",
  SLOTS_upline_pt_required: "[Livecasino] តម្រូវឲ្យបញ្ចូល PT របស់ឪពុក/ម្ដាយ។",
  SLOTS_pt_setting_exists: "[Livecasino] ការកំណត់ PT មានរួចហើយ។",
  SLOTS_parent_pt_not_exists: "[Livecasino] ការកំណត់ PT របស់ឪពុក/ម្ដាយមិនមានទេ។",
  SLOTS_parent_min_not_meet: "[Livecasino] មិនត្រូវនឹង PT អប្បបរមារបស់ឪពុក/ម្ដាយ។",
  SLOTS_exceeded_parent_pt: "[Livecasino] លើសការកំណត់ PT របស់ឪពុក/ម្ដាយ។",
  SLOTS_account_pt_required: "[Livecasino] តម្រូវឲ្យបញ្ចូល PT របស់គណនី។",
  SLOTS_upline_remaining_required: "[Livecasino] តម្រូវឲ្យបញ្ចូល PT នៅសល់របស់ឪពុក/ម្ដាយ។",
  SLOTS_account_min_required: "[Livecasino] តម្រូវឲ្យបញ្ចូល PT អប្បបរមារបស់គណនី។",
  SLOTS_upline_remaining_gt_account_pt: "[Livecasino] PT នៅសល់របស់ឪពុក/ម្ដាយធំជាង PT របស់គណនី។",
  SLOTS_account_min_gt_pt: "[Livecasino] PT អប្បបរមារបស់គណនីធំជាង PT របស់ឪពុក/ម្ដាយ។",
  bet_type_required: "តម្រូវឲ្យបញ្ចូលប្រភេទភ្នាល់។",
  schedule_1_to_7_required: "តម្រូវឲ្យបញ្ចូលកាលវិភាគសងប្រាក់។",
  schedule_exists: "កាលវិភាគសងប្រាក់មានរួចហើយ។",
  parent_schedule_not_exists: "កាលវិភាគសងប្រាក់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  schedule_1_not_available: "កាលវិភាគសងប្រាក់ថ្ងៃច័ន្ទមិនអាចប្រើបាន។",
  schedule_2_not_available: "កាលវិភាគសងប្រាក់ថ្ងៃអង្គារ៍មិនអាចប្រើបាន។",
  schedule_3_not_available: "កាលវិភាគសងប្រាក់ថ្ងៃពុធមិនអាចប្រើបាន។",
  schedule_4_not_available: "កាលវិភាគសងប្រាក់ថ្ងៃព្រហស្បតិ៍មិនអាចប្រើបាន។",
  schedule_5_not_available: "កាលវិភាគសងប្រាក់ថ្ងៃសុក្រ​មិនអាចប្រើបាន។",
  schedule_6_not_available: "កាលវិភាគសងប្រាក់ថ្ងៃសៅរ៍មិនអាចប្រើបាន។",
  schedule_7_not_available: "កាលវិភាគសងប្រាក់ថ្ងៃអាទិត្យមិនអាចប្រើបាន។",
  credit_limit_required: "តម្រូវឲ្យបញ្ចូលកំណត់ឥណទាន។",
  member_credit_limit_required: "តម្រូវឲ្យបញ្ចូលកំណត់ឥណទានសមាជិក។",
  wallet_exists: "គណនីមានរួចហើយ។",
  member_credit_limit_gt_credit_limit: "កំណត់ឥណទានសមាជិកធំជាងកំណត់ឥណទាន។",
  parent_wallet_not_exists: "គណនីមិនមានទេ។",
  account_credit_limit_gt_parent: "កំណត់ឥណទានគណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  member_credit_limit_gt_parent: "កំណត់ឥណទានសមាជិកធំជាងរបស់ឪពុក/ម្ដាយ។",
  exceeded_credit_limit: "លើសកំណត់ឥណទានគណនី។",
  soccer_min_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អប្បបរមា។",
  soccer_max_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមា។",
  soccer_max_per_match_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមាក្នុងមួយប្រកួត។",
  soccer_bet_limit_exists: "កំណត់ភ្នាល់មានរួចហើយ។",
  soccer_parent_bet_limit_not_exists: "កំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  soccer_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  soccer_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  soccer_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  basketball_min_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អប្បបរមា។",
  basketball_max_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមា។",
  basketball_max_per_match_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមាក្នុងមួយប្រកួត។",
  basketball_bet_limit_exists: "កំណត់ភ្នាល់មានរួចហើយ។",
  basketball_parent_bet_limit_not_exists: "កំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  basketball_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  basketball_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  basketball_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  tennis_min_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អប្បបរមា។",
  tennis_max_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមា។",
  tennis_max_per_match_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមាក្នុងមួយប្រកួត។",
  tennis_bet_limit_exists: "កំណត់ភ្នាល់មានរួចហើយ។",
  tennis_parent_bet_limit_not_exists: "កំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  tennis_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  tennis_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  tennis_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  baseball_min_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អប្បបរមា។",
  baseball_max_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមា។",
  baseball_max_per_match_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមាក្នុងមួយប្រកួត។",
  baseball_bet_limit_exists: "កំណត់ភ្នាល់មានរួចហើយ។",
  baseball_parent_bet_limit_not_exists: "កំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  baseball_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  baseball_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  baseball_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  parlay_min_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អប្បបរមា។",
  parlay_max_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមា។",
  parlay_max_per_match_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមាក្នុងមួយប្រកួត។",
  parlay_bet_limit_exists: "កំណត់ភ្នាល់មានរួចហើយ។",
  parlay_parent_bet_limit_not_exists: "កំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  parlay_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  parlay_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  parlay_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  esports_min_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អប្បបរមា។",
  esports_max_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមា។",
  esports_max_per_match_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមាក្នុងមួយប្រកួត។",
  esports_bet_limit_exists: "កំណត់ភ្នាល់មានរួចហើយ។",
  esports_parent_bet_limit_not_exists: "កំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  esports_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  esports_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  esports_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  others_min_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អប្បបរមា។",
  others_max_bet_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមា។",
  others_max_per_match_required: "តម្រូវឲ្យបញ្ចូលភ្នាល់អតិបរមាក្នុងមួយប្រកួត។",
  others_bet_limit_exists: "កំណត់ភ្នាល់មានរួចហើយ។",
  others_parent_bet_limit_not_exists: "កំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  others_account_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតិចជាងរបស់ឪពុក/ម្ដាយ។",
  others_account_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  others_account_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីធំជាងរបស់ឪពុក/ម្ដាយ។",
  used_credit_gt_credit_limit: "ប្រាក់ឥណទានប្រើប្រាស់លើសពីដែនកំណត់។",
  bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់មិនមានទេ។",
  parent_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  package_not_exists_in_parent: "កញ្ចប់កំណត់ភ្នាល់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  soccer_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់បាល់ទាត់មិនមានទេ។",
  soccer_update_interval_violated: "លំដាប់ពេលវេលាធ្វើបច្ចុប្បន្នភាពបានរំលោភ។",
  basketball_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់បាល់បោះមិនមានទេ។",
  basketball_update_interval_violated: "លំដាប់ពេលវេលាធ្វើបច្ចុប្បន្នភាពបានរំលោភ។",
  tennis_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់តេននីសមិនមានទេ។",
  tennis_update_interval_violated: "លំដាប់ពេលវេលាធ្វើបច្ចុប្បន្នភាពបានរំលោភ។",
  baseball_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់បេសបុលមិនមានទេ។",
  baseball_update_interval_violated: "លំដាប់ពេលវេលាធ្វើបច្ចុប្បន្នភាពបានរំលោភ។",
  parlay_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់បរមាណគ្នាមិនមានទេ។",
  parlay_update_interval_violated: "លំដាប់ពេលវេលាធ្វើបច្ចុប្បន្នភាពបានរំលោភ។",
  esports_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់អេសផតមិនមានទេ។",
  esports_update_interval_violated: "លំដាប់ពេលវេលាធ្វើបច្ចុប្បន្នភាពបានរំលោភ។",
  others_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់ផ្សេងទៀតមិនមានទេ។",
  others_update_interval_violated: "លំដាប់ពេលវេលាធ្វើបច្ចុប្បន្នភាពបានរំលោភ។",
  soccer_parent_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់បាល់ទាត់របស់ឪពុក/ម្ដាយមិនមានទេ។",
  soccer_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីបាល់ទាត់តិចជាងរបស់ឪពុក/ម្ដាយ។",
  soccer_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីបាល់ទាត់ធំជាងរបស់ឪពុក/ម្ដាយ។",
  soccer_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីបាល់ទាត់ធំជាងរបស់ឪពុក/ម្ដាយ។",
  basketball_parent_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់បាល់បោះរបស់ឪពុក/ម្ដាយមិនមានទេ។",
  basketball_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីបាល់បោះតិចជាងរបស់ឪពុក/ម្ដាយ។",
  basketball_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីបាល់បោះធំជាងរបស់ឪពុក/ម្ដាយ។",
  basketball_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីបាល់បោះធំជាងរបស់ឪពុក/ម្ដាយ។",
  tennis_parent_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់តេននីសរបស់ឪពុក/ម្ដាយមិនមានទេ។",
  tennis_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីតេននីសតិចជាងរបស់ឪពុក/ម្ដាយ។",
  tennis_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីតេននីសធំជាងរបស់ឪពុក/ម្ដាយ។",
  tennis_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីតេននីសធំជាងរបស់ឪពុក/ម្ដាយ។",
  baseball_parent_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់បេសបុលរបស់ឪពុក/ម្ដាយមិនមានទេ។",
  baseball_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីបេសបុលតិចជាងរបស់ឪពុក/ម្ដាយ។",
  baseball_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីបេសបុលធំជាងរបស់ឪពុក/ម្ដាយ។",
  baseball_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីបេសបុលធំជាងរបស់ឪពុក/ម្ដាយ។",
  parlay_parent_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់បរមាណគ្នារបស់ឪពុក/ម្ដាយមិនមានទេ។",
  parlay_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីបរមាណគ្នាតិចជាងរបស់ឪពុក/ម្ដាយ។",
  parlay_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីបរមាណគ្នាធំជាងរបស់ឪពុក/ម្ដាយ។",
  parlay_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីបរមាណគ្នាធំជាងរបស់ឪពុក/ម្ដាយ។",
  esports_parent_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់អេសផតរបស់ឪពុក/ម្ដាយមិនមានទេ។",
  esports_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីអេសផតតិចជាងរបស់ឪពុក/ម្ដាយ។",
  esports_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីអេសផតធំជាងរបស់ឪពុក/ម្ដាយ។",
  esports_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីអេសផតធំជាងរបស់ឪពុក/ម្ដាយ។",
  others_parent_bet_limit_setting_not_exists: "ការកំណត់ភ្នាល់ផ្សេងទៀតរបស់ឪពុក/ម្ដាយមិនមានទេ។",
  others_min_bet_lt_parent: "ភ្នាល់អប្បបរមារបស់គណនីផ្សេងទៀតតិចជាងរបស់ឪពុក/ម្ដាយ។",
  others_max_bet_gt_parent: "ភ្នាល់អតិបរមារបស់គណនីផ្សេងៗធំជាងរបស់ឪពុក/ម្ដាយ។",
  others_max_per_match_gt_parent: "ភ្នាល់អតិបរមាក្នុងមួយប្រកួតរបស់គណនីផ្សេងៗធំជាងរបស់ឪពុក/ម្ដាយ។",
  update_interval_violated: "បានរំលោភលំដាប់ពេលវេលាបច្ចុប្បន្នភាព។",
  exceeded_parent_others: "លើសការកំណត់គម្រោងចំណែករបស់ឪពុក/ម្ដាយសម្រាប់ Others។",
  exceeded_parent_hdp: "លើសការកំណត់ភ្នាល់ HDP របស់ឪពុក/ម្ដាយ។",
  soccer_min_bet_gt_max_bet: "ភ្នាល់អប្បបរមាត្រូវតិចជាងឬស្មើនឹងភ្នាល់អតិបរមា។",
  soccer_max_bet_gt_max_per_match: "ភ្នាល់អតិបរមាត្រូវតិចជាងឬស្មើនឹងអតិបរមាក្នុងមួយប្រកួត។",
  basketball_min_bet_gt_max_bet: "ភ្នាល់អប្បបរមាត្រូវតិចជាងឬស្មើនឹងភ្នាល់អតិបរមា។",
  basketball_max_bet_gt_max_per_match: "ភ្នាល់អតិបរមាត្រូវតិចជាងឬស្មើនឹងអតិបរមាក្នុងមួយប្រកួត។",
  tennis_min_bet_gt_max_bet: "ភ្នាល់អប្បបរមាត្រូវតិចជាងឬស្មើនឹងភ្នាល់អតិបរមា។",
  tennis_max_bet_gt_max_per_match: "ភ្នាល់អតិបរមាត្រូវតិចជាងឬស្មើនឹងអតិបរមាក្នុងមួយប្រកួត។",
  baseball_min_bet_gt_max_bet: "ភ្នាល់អប្បបរមាត្រូវតិចជាងឬស្មើនឹងភ្នាល់អតិបរមា។",
  baseball_max_bet_gt_max_per_match: "ភ្នាល់អតិបរមាត្រូវតិចជាងឬស្មើនឹងអតិបរមាក្នុងមួយប្រកួត។",
  parlay_min_bet_gt_max_bet: "ភ្នាល់អប្បបរមាត្រូវតិចជាងឬស្មើនឹងភ្នាល់អតិបរមា។",
  parlay_max_bet_gt_max_per_match: "ភ្នាល់អតិបរមាត្រូវតិចជាងឬស្មើនឹងអតិបរមាក្នុងមួយប្រកួត។",
  esports_min_bet_gt_max_bet: "ភ្នាល់អប្បបរមាត្រូវតិចជាងឬស្មើនឹងភ្នាល់អតិបរមា។",
  esports_max_bet_gt_max_per_match: "ភ្នាល់អតិបរមាត្រូវតិចជាងឬស្មើនឹងអតិបរមាក្នុងមួយប្រកួត។",
  others_min_bet_gt_max_bet: "ភ្នាល់អប្បបរមាត្រូវតិចជាងឬស្មើនឹងភ្នាល់អតិបរមា។",
  others_max_bet_gt_max_per_match: "ភ្នាល់អតិបរមាត្រូវតិចជាងឬស្មើនឹងអតិបរមាក្នុងមួយប្រកួត។",

  valid: "{fname} ត្រូវមានអក្សរធំ១ ខ្ទង់ អក្សរតូច១ ខ្ទង់ និងលេខ១ ខ្ទង់។ (ឧ. Abcd1234)",
  notSame: "ពាក្យសម្ងាត់ថ្មីមិនអាចដូចនឹងពាក្យសម្ងាត់ចាស់បានទេ។"
};
